module.exports = __webpack_public_path__ + "static/media/ic_calendar.451bd3ff.svg";